// File: @/components/analytics/analytics-debug-probe.tsx

'use client';

import { useEffect, useRef } from 'react';

import { ENV } from '@/config/constants';
import { ctaClickEvent, track } from '@/lib/analytics';

const PROBE_ELEMENT_ID = '__analytics_debug_probe__';
const PROBE_ELEMENT_TEXT = 'Analytics Debug Probe';
const PROBE_PLACEMENT = 'analytics_debug_probe';

export default function AnalyticsDebugProbe(): null {
  const hasFiredRef = useRef<boolean>(false);

  useEffect(() => {
    if (hasFiredRef.current) {
      return;
    }

    if (!ENV.isAnalyticsDebugEnabled || ENV.isProductionAnalytics) {
      return;
    }

    hasFiredRef.current = true;

    track(ctaClickEvent(PROBE_ELEMENT_ID, PROBE_ELEMENT_TEXT, PROBE_PLACEMENT));
  }, []);

  return null;
}
